import ChangePasswordModal from "../Components/ChangePasswordModal";
import { useCallback } from "react";

export default function ChangePassword() {
  const handleClose = useCallback(() => {}, []);
  return (
    <ChangePasswordModal isOpen={true} onClose={handleClose} />
  )
}